export const APP_NAME = 'amïca';
export const APP_ID = 'lsc-odrs';
